module.exports = __webpack_public_path__ + "media/images/icons/country_flags/yt-433b076a0fbb984af9f2bc023eea5232.svg";